import { provideState } from '@ngrx/store';
import { FUNDING_FEATURE_KEY, FundingEffects, FundingFacade, fundingReducer } from './+state';
import { provideEffects } from '@ngrx/effects';

export * from './+state';


export const fundingProviders = [

  // ngrx
  FundingFacade,
  provideState(FUNDING_FEATURE_KEY, fundingReducer),
  provideEffects(FundingEffects),
];
